import { EntityId } from "@reduxjs/toolkit";
import React from "react";
import FilterCategoryContainer from "../../../category/container/filter.category.container/FilterCategoryContainer";
import { Category } from "../../../category/types/types";
import { Project } from "../../../project/types/types";
import {
  CreateStudentFormCol,
  CreateStudentFormRow,
  LabelStudent
} from "../../../students/presantation/student.details.info.presentation/student.details.info.style";
import FilterSubCategoryContainer from "../../../subcategory/container/FilterSubcategoryContainer/FilterSubCategoryContainer";
import { SubCategory } from "../../../subcategory/types/types";
type ShopFilterPresentationProps = {
  category: Partial<Category> | null;
  subCategory: Partial<SubCategory> | null;
  onCategory: (category: Partial<Category> | null) => void;
  onSubCategory: (subCategory: Partial<SubCategory> | null) => void;
  project: Partial<Project>;
  defaultValue?: string;
};
const ShopFilterPresentation: React.FC<ShopFilterPresentationProps> = ({
  category,
  subCategory,
  onCategory,
  onSubCategory,
  project,
}) => {
  return (
    <CreateStudentFormRow style={{ marginTop: 0 }}>
      <CreateStudentFormCol Direction="column">
        <LabelStudent>Category</LabelStudent>
        <FilterCategoryContainer
          projectID={project._id! as EntityId}
           selectedDefault={category?._id as string}
          onSelectCategory={onCategory}
          page="shop"
        />
      </CreateStudentFormCol>
      <CreateStudentFormCol Direction="column">
        <LabelStudent>Sub Category</LabelStudent>
        <FilterSubCategoryContainer
          categoryID={category?._id!}
          defaultValue={subCategory!}
          onSelectSubCategory={onSubCategory}
        />
      </CreateStudentFormCol>
    </CreateStudentFormRow>
  )
}

export default ShopFilterPresentation
